import { Button, Paper, Stack } from '@mui/material'
import { useState } from 'react'

enum REWARDS_TABS {
    CHALLENGES = 'challenges',
    ACHIEVEMENTS = 'achievements',
}

const REWARDS_CONTENT = {
    [REWARDS_TABS.CHALLENGES]: <div>Challenges Content</div>,
    [REWARDS_TABS.ACHIEVEMENTS]: <div>Achievements Content</div>,
}

export const Rewards = () => {
    const [tab, setTab] = useState(REWARDS_TABS.CHALLENGES)

    return (
        <>
            <Stack direction="row" spacing={1} mb="-2px" px={1} zIndex={0}>
                {Object.values(REWARDS_TABS).map((item) => (
                    <Button tab size="large" onClick={() => setTab(item)} fullWidth selected={item === tab}>
                        {item}
                    </Button>
                ))}
            </Stack>

            <Paper sx={{ display: 'flex', flexGrow: 1 }} variant="outlined">
                {REWARDS_CONTENT[tab]}
            </Paper>
        </>
    )
}
